// extracted by mini-css-extract-plugin
export default {"bridge":"ApplicationRow_bridge__Z16Gu","disabled":"ApplicationRow_disabled__w-7mP"};